<template>
  <div>
    <div class="billingMonitor-title">
      <div>{{ $t("alarms.billing.billing") }}</div>
      <div>
        <Button
          type="primary"
          @click="addOrUpdateHandle"
          v-hasPermission="['monitor:billingMonitor:add_alert_rule']"
          >{{ $t("alarms.billing.addBillingAlarm") }}</Button
        >
        <add-or-update-billing-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-billing-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.common.alertRule')">
          <div class="billingMonitor-top">
            <billing-warning-search></billing-warning-search>
          </div>
          <table-billing-warning></table-billing-warning>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import BillingWarningSearch from "../billing/BillingWarningSearch";
import TableBillingWarning from "../billing/TableBillingWarning";
import AddOrUpdateBillingWarning from "../billing/AddOrUpdateBillingWarning";

export default {
  name: "BillingMonitor",
  components: {
    BillingWarningSearch,
    TableBillingWarning,
    AddOrUpdateBillingWarning
  },
  data() {
    return {
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    }
  }
};
</script>

<style scoped>
.billingMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.billingMonitor-title > div:nth-child(1) {
  float: left;
}
.billingMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.billingMonitor-top {
  width: 100%;
  /* height: 32px; */
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/billing/BillingMonitor.vue